export const GuestBrandedDefaultColors = Object.freeze({
    background: '#F7F7F7',
    text: '#1C1F25',
    textHover: '#8C8F95',
    action: '#723D9E',
    actionText: '#FFFFFF',
    actionHover: '#7A49A4',
    actionActive: '#885fB0',
    border: '#8C8F95',
});

export const GuestBrandedDefaultFonts = Object.freeze({
    body: 'Lato, sans-serif',
    heading: 'Lato, sans-serif',
    subHeading: 'Lato, sans-serif',
    button: 'Lato, sans-serif',
});

export const TENANT_TYPE_ORG = 'ORGANIZATION';
export const TENANT_TYPE_EVENT = 'EVENT';

export const DONS_ORIGIN_ORG = 'organization';
export const DONS_ORIGIN_EVENT = 'event';

export const BANNER_COLOR_LIGHT = 'LIGHT';
export const BANNER_COLOR_DARK = 'DARK';

export const GUEST_INFORMATION = 'GUEST_INFORMATION';
